import { useFrame, useLoader, useThree } from "@react-three/fiber";
import { useCharacterStore } from "@src/stores/characterStore";
import { useRef } from "react";
import { TextureLoader } from "three";

/**
 * Displays a given image as a Sprite.
 * Uses the scale and position given in props.
 */
const Sprite = ({
    url,
    position,
    onClick,
    scale,
    index,
}: {
    url: string;
    position: number[];
    scale: number;
    index: number;
    onClick: () => void;
}) => {
    function resizeImage(height: number, width: number) {
        const newWidth = (width / height) * 2000;
        return [2000, newWidth];
    }
    const { selectedVersion, selectedExpression } = useCharacterStore(
        (state) => ({
            selectedExpression: state.selectedExpression,
            selectedVersion: state.selectedVersion,
        }),
    );
    const selected = selectedVersion == index;
    const map = useLoader(TextureLoader, url);
    let exp;
    if (selectedExpression !== "" && selected) {
        exp = useLoader(TextureLoader, selectedExpression);
    }
    // Temp scaling
    const [imgHeight, imgWidth] = resizeImage(
        map.image.height,
        map.image.width,
    );
    const windowRatio = Math.min(
        (window.innerWidth / window.innerHeight) * 1000,
        500,
    );
    const scaleY = (imgHeight * scale) / windowRatio;
    const scaleX = (imgWidth * scale) / windowRatio;
    const shadowRef = useRef(null);
    const { camera } = useThree();
    useFrame(() => {
        //@ts-ignore yes it does
        shadowRef.current?.rotation.copy(camera.rotation);
        //@ts-ignore
        shadowRef.current.rotation.z = 0;
    });
    return (
        <group position={[position[0], position[1], position[2]]}>
            <sprite
                renderOrder={9}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
                scale={[scaleX, scaleY, 1]}
                //@ts-ignore No it isn't
                center={[0.5, 0]}
            >
                <spriteMaterial
                    depthTest={false}
                    map={map}
                    opacity={selected ? 1 : 0.9}
                />
            </sprite>
            {selectedExpression !== "" && selected && (
                <sprite
                    renderOrder={10}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClick();
                    }}
                    scale={[scaleX, scaleY, 1]}
                    //@ts-ignore No it isn't
                    center={[0.5, 0]}
                >
                    <spriteMaterial depthTest={false} map={exp} />
                </sprite>
            )}
            <mesh
                //@ts-ignore
                ref={shadowRef}
                position={[0.05, 0.05, 0]}
                scale={[scaleX, 1, 1]}
                renderOrder={1}
            >
                {/* @ts-ignore yes it does */}
                <roundedPlaneGeometry args={[1.2, 0.3, 0.1]} />
                <meshBasicMaterial
                    transparent={true}
                    opacity={0.1}
                    color="#4F46E5"
                />
            </mesh>
        </group>
    );
};
export default Sprite;
